import { CommunityApiEndpoint } from '@core/api-endpoint';
import {
  FetchNewMainBannersPayload,
  FetchNewMainBannersResponse,
  FetchNewMainBoardsPayload,
  FetchNewMainBoardsResponse,
  FetchPostIdPayload,
  FetchPostListPayload,
  FetchPostListResponse,
  Post,
  PostPayload,
  UpdatePostPayload,
} from '@core/dto';
import { HttpInterface } from '@core/http';
import { CommunityPort } from '@core/ports';

export class CommunityAdapter
  implements
    CommunityPort<
      any,
      | PostPayload
      | UpdatePostPayload
      | FetchNewMainBoardsPayload
      | FetchNewMainBannersPayload
      | FetchPostListPayload
      | FetchPostIdPayload
    >
{
  http: HttpInterface;
  constructor(http: HttpInterface) {
    this.http = http;
  }

  async fetchPostId(payload: FetchPostIdPayload): Promise<number> {
    const url = this.http.replacedUrl(CommunityApiEndpoint.fetchPostId, {
      boardId: payload.boardId,
    });
    const response = await this.http.post<number>(url);
    return response.data;
  }

  async fetchPostList(
    payload: FetchPostListPayload
  ): Promise<FetchPostListResponse> {
    const { boardId } = payload;
    const url = this.http.replacedUrl(CommunityApiEndpoint.fetchPostList, {
      boardId,
    });
    const response = await this.http.get<FetchPostListResponse>(url, payload);
    return response.data;
  }

  async fetchPost(payload: PostPayload): Promise<Post> {
    const url = this.http.replacedUrl(CommunityApiEndpoint.fetchPost, {
      boardId: payload.boardId,
      postId: payload.postId,
    });
    const response = await this.http.get<Post>(url);
    return response.data;
  }

  async updatePost(payload: UpdatePostPayload): Promise<any> {
    const replacedUrl = this.http.replacedUrl(CommunityApiEndpoint.updatePost, {
      boardId: payload.boardId,
    });
    await this.http.patch<any>(replacedUrl, payload);
  }

  async deletePost(payload: PostPayload): Promise<void> {
    const url = this.http.replacedUrl(CommunityApiEndpoint.deletePost, payload);
    await this.http.delete(url);
  }

  async fetchMainBoards(
    payload: FetchNewMainBoardsPayload
  ): Promise<FetchNewMainBoardsResponse[]> {
    const response = await this.http.get<FetchNewMainBoardsResponse[]>(
      CommunityApiEndpoint.fetchMainBoards,
      payload
    );
    return response.data;
  }

  async fetchMainBanners(
    payload: FetchNewMainBannersPayload
  ): Promise<FetchNewMainBannersResponse> {
    const response = await this.http.get<FetchNewMainBannersResponse>(
      CommunityApiEndpoint.fetchMainBanners,
      payload
    );
    return response.data;
  }
}
